import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  PERMISSION_DELETE_PERMISSION_BEGIN,
  PERMISSION_DELETE_PERMISSION_SUCCESS,
  PERMISSION_DELETE_PERMISSION_FAILURE,
  PERMISSION_DELETE_PERMISSION_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie } from '../../../common/utils/api_utils';

export function deletePermission(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: PERMISSION_DELETE_PERMISSION_BEGIN,
    });
    const { flags, projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.patch(
        `${process.env.REACT_APP_BUILDER_ENGINE}permissions/`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: PERMISSION_DELETE_PERMISSION_SUCCESS,
              data: res.data,
            });

            toast.success('Permissions Updated Successfully!');
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: PERMISSION_DELETE_PERMISSION_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }
        },
        (err) => {
          console.log('err.response :>> ', err.response);
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          if (err.response.status && err.response.status === 400) {
            dispatch({
              type: PERMISSION_DELETE_PERMISSION_FAILURE,
              data: { error: errMsg },
            });
            resolve(errMsg);
          }
          dispatch({
            type: PERMISSION_DELETE_PERMISSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeletePermissionError() {
  return {
    type: PERMISSION_DELETE_PERMISSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERMISSION_DELETE_PERMISSION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deletePermissionPending: true,
        deletePermissionError: null,
      };

    case PERMISSION_DELETE_PERMISSION_SUCCESS:
      // The request is success
      return {
        ...state,
        deletePermissionPending: false,
        deletePermissionError: null,
      };

    case PERMISSION_DELETE_PERMISSION_FAILURE:
      // The request is failed
      return {
        ...state,
        deletePermissionPending: false,
        deletePermissionError: action.data.error,
      };

    case PERMISSION_DELETE_PERMISSION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deletePermissionError: null,
      };

    default:
      return state;
  }
}
